import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BreadcrumbCrumb } from '../../core/seo/breadcrumb-trail';

/**
 * The site's breadcrumb trail.
 *
 * One component for every page, because there were six hand-rolled versions before it — five class
 * names (`sav-breadcrumb`, `sav-ch-crumbs`, `sav-cc-crumbs`, `sav-experts-crumbs`,
 * `sav-expert-crumbs`), two separators (`/` and `›`) and a Tailwind-styled blog variant — while
 * sixteen other page types showed no trail at all despite already emitting BreadcrumbList schema.
 *
 * Markup follows the pattern Google documents: an ordered list inside a labelled `<nav>`, with the
 * current page as plain text carrying `aria-current="page"` rather than a link to itself. The
 * separators are `aria-hidden`, so a screen reader hears the list, not a run of slashes.
 *
 * Feed it the same array you pass to `breadcrumbSchemaFor` — see breadcrumb-trail.ts.
 */
@Component({
  selector: 'app-breadcrumb',
  imports: [RouterLink],
  templateUrl: './breadcrumb.html',
  styleUrl: './breadcrumb.scss',
})
export class Breadcrumb {
  readonly items = input.required<BreadcrumbCrumb[]>();

  /**
   * Extra classes on the `<nav>`, for the few pages that need it to sit on a dark hero.
   * `app-breadcrumb variant="on-dark"` is the only one defined.
   */
  readonly variant = input<'' | 'on-dark'>('');
}
